import CheckoutPagarme from './CheckoutPagarme';

export default CheckoutPagarme;
